/* src/app/modules/reports/pages/report/report.component.scss */
:host ion-content {
  --background: var(--ion-color-primary) ;
}
/*# sourceMappingURL=report.component-LS5FK56U.css.map */
